import { Location } from '@angular/common';
import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { ToastsManager } from 'ng2-toastr';
import { Observable } from 'rxjs';
import { IncidentAccidentModel } from '../../../models/incidentAccidentModel';
import { IncidentAccidentServiceService, ModuleService, SettingsService, SiteService } from '../../../services';
import { DateHelper, DeviceHelper } from '../../../shared/helpers';
@Component({
    selector: 'app-incident-accident-create',
    templateUrl: './incident-accident-create.component.html',
    styleUrls: ['./incident-accident-create.component.scss']
})
export class IncidentAccidentCreateComponent implements OnInit {
    showSpinner: false;
    model: IncidentAccidentModel = new IncidentAccidentModel();
    saving: boolean = false;
    module: any;
    sites: any = [];
    skadetypes: any = [];
    skadetypesLoading: boolean = false;
    @ViewChild('form') form: FormGroup;
    constructor(private settingService: SettingsService,
        public location: Location,
        private route: ActivatedRoute,
        private moduleService: ModuleService,
        private siteService: SiteService,
        private incidentAccidentSerice: IncidentAccidentServiceService,
        private toastr: ToastsManager,
        private vRef: ViewContainerRef) {
        this.toastr.setRootViewContainerRef(vRef);
    }
    formType: string = "Incident";
    isMobile: boolean
    ngOnInit() {
        this.isMobile = DeviceHelper.isMobile() ? true : false
        var now = new Date();

        this.model.Date = { year: now.getFullYear(), month: now.getMonth() + 1, day: now.getDate() };
        this.model.Time = <NgbTimeStruct>{ hour: now.getHours(), minute: now.getMinutes(), second: now.getSeconds() };

        this.route.params.subscribe((params) => {
            if (params) {
                const id = params['id'];
                const type = params['type'];

                if (type == 0) {
                    this.formType = "Incident";
                }
                else if (type == 1) {
                    this.formType = "Accident";
                }

                this.model.SiteId = id;
                var user = JSON.parse(localStorage.getItem('currentUser'));
                this.model.AccountId = user.accountId

                this.settingService.getValue("AccidentEmail", user.accountId)
                    .catch((err: any) => {
                        return Observable.throw(err);
                    })
                    .finally(() => {
                        setTimeout(() => {
                        }, 1000);
                    })
                    .subscribe((response: any) => {
                        if (response.Data != null) {
                            this.model.DefaultEmail = response.Data.Value;
                        }
                    });

                this.loadSites(user.accountId);
            }
        });

    }

    saveChanges() {
        if (this.form.invalid) {
            this.toastr.error("Please check and fill in all required fields.", "Invalid or incomplete input");
            return;
        }
        this.saving = true;

        this.incidentAccidentSerice.saveIncidentAccident(this.model)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {

                }, 1000);
            })
            .subscribe((response: any) => {
                this.saving = false;

                //this.ngOnInit();
                this.location.back();
            });

    }
    setDisabled() {

        if (this.formType == 'Accident' && (this.model.Skadetyp == 0 || this.model.Skadetyp == undefined)) {
            return true;
        }

        if (this.model.Location == "" || this.model.Location == undefined) {
            return true;
        }
        if (this.model.Affected == "" || this.model.Affected == undefined) {
            return true;
        }
        if (this.model.Event == "" || this.model.Event == undefined) {
            return true;
        }
        if (this.model.ProbableCause == "" || this.model.ProbableCause == undefined) {
            return true;
        }

        if (this.formType != 'Accident' && (this.model.Damages == "" || this.model.Damages == undefined)) {
            return true;
        }
        if (this.model.Reporter == "" || this.model.Reporter == undefined) {
            return true;
        }
        if (this.model.Email == '' && this.model.Email == undefined) {
            return true;
        }
        if (this.model.Phone == '' && this.model.Phone == undefined) {
            return true;
        }

        return false;
    }
    loadSites(accountId: number) {
        var user = JSON.parse(localStorage.getItem('currentUser'));

        this.moduleService.getModuleByTitle("Incident Accident")
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {

                }, 1000);
            })
            .subscribe((resp: any) => {

                this.module = resp.Data;

                this.siteService.getByAccountIdAndUserId(accountId, user.id, this.module.Id)
                    .catch((err: any) => {
                        return Observable.throw(err);
                    })
                    .finally(() => {
                        setTimeout(() => {

                        }, 1000);
                    })
                    .subscribe((response: any) => {
                        this.sites = response.Data;
                        this.model.SiteName = this.sites.find(x => x.Id == this.model.SiteId).Name
                        if (this.model.SiteId == null || this.model.SiteId == 0) {

                            if (this.sites == undefined || this.sites.length == 0) {
                                return;
                            }

                            if (this.sites.filter(x => x.Id == this.model.SiteId).length <= 0) {
                                this.model.SiteId = this.sites[0].Id;
                                this.model.SiteName = this.sites[0].Name
                            }
                        }

                    });
            });

    }

    loadSkadetypes() {

        if (this.model.AccidentType != undefined && this.model.AccidentType != 0) {
            this.skadetypesLoading = true;
            var user = JSON.parse(localStorage.getItem('currentUser'));
            this.incidentAccidentSerice.GetSkadetypes(this.model.AccidentType, user.accountId)
                .catch((err: any) => {
                    return Observable.throw(err);
                })
                .finally(() => {
                    setTimeout(() => {

                    }, 1000);
                })
                .subscribe((response: any) => {
                    this.skadetypes = response.Data;
                    this.model.Skadetyp = 0;
                    this.skadetypesLoading = false;
                });
        }

    }

}



// WEBPACK FOOTER //
// ./src/app/incident-accident/components/incident-accident-create/incident-accident-create.component.ts